
import { toast } from "sonner";

// Centralized toast service using only Sonner
export const toastService = {
  /**
   * Shows a success toast with a standard duration of 2 seconds
   */
  success: (message: string) => {
    return toast.success(message, {
      duration: 2000,
    });
  },

  /**
   * Shows an error toast with a longer duration
   */
  error: (message: string) => {
    return toast.error(message);
  },

  /**
   * Shows an info toast
   */
  info: (message: string) => {
    return toast.info(message);
  },

  /**
   * Shows a loading toast that can be dismissed
   */
  loading: (message: string) => {
    return toast.loading(message, {
      duration: 30000 // Auto-dismiss after 30 seconds to prevent stuck toasts
    });
  },

  /**
   * Dismiss a toast by its ID
   */
  dismiss: (toastId: string | number) => {
    toast.dismiss(toastId);
  },

  /**
   * Dismiss all active toasts
   */
  dismissAll: () => {
    toast.dismiss();
  }
};
